import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { PageComponent } from "@components/page/page.component";
import { RaskRoller } from "~app/common/models/constants";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { CommonTexts } from "~app/features/virkeskop/common/common-texts";
import { AnbudKontraktListComponent } from "./anbud-kontrakt-list/anbud-kontrakt-list.component";
import { AnbudKontraktSearchService } from "./services/anbud-kontrakt-search.service";
import { KontraktSearchMinaFilterService } from "./sok-anbud-kontrakt/kontrakt-search-mina-filter/kontrakt-search-mina-filter.service";
import { KONTRAKT_FILTER_KEY, KONTRAKT_SEARCH_KEY } from "./sok-anbud-kontrakt/kontrakt-search-mina-filter/kontrakt-token-keys";
import { SokAnbudKontraktComponent } from "./sok-anbud-kontrakt/sok-anbud-kontrakt.component";

@Component({
    selector: "rask-anbud-kontrakt",
    templateUrl: "./anbud-kontrakt.component.html",
    styleUrls: ["./anbud-kontrakt.component.scss"],
    providers: [
        { provide: KONTRAKT_FILTER_KEY,
            useValue: "virkeskop.anbudkontrakt.sparade" },
        KontraktSearchMinaFilterService,
        { provide: KONTRAKT_SEARCH_KEY,
            useValue: "virkeskop.anbudkontrakt.searchparams" },
        AnbudKontraktSearchService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        SokAnbudKontraktComponent,
        AnbudKontraktListComponent
    ]
})
export class AnbudKontraktComponent implements OnInit {
    isKopledaOrVirkeskopa: boolean;
    texts = CommonTexts.texts;
    title = CommonTexts.texts.sokAnbudKontrakt;

    private readonly authenticationService = inject(AuthenticationService);
    private readonly router = inject(Router);

    ngOnInit(): void {
        this.isKopledaOrVirkeskopa = this.authenticationService.hasRoles([
            RaskRoller.role.Kopleda,
            RaskRoller.role.Virkeskopa
        ]);
    }

    skapaAnbudKontrakt = () => {
        this.router.navigate(["/virkeskop/avtal/ny"]);
    };
}
